import React, { FC, SVGProps } from 'react';
import { ReactComponent as VisaLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/visa-logo.svg';
import { ReactComponent as MastercardLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/mastercard-logo.svg';
import { ReactComponent as AmexLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/amex-logo.svg';
import { ReactComponent as DiscoverLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/discover-logo.svg';
import { ReactComponent as JcbLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/jcb-logo.svg';
import { ReactComponent as DinersClubLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/diners-club-logo.svg';
import { ReactComponent as UnionPayLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/unionpay-logo.svg';
import { ReactComponent as MaestroLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/maestro-logo.svg';
import { ReactComponent as GenericCardLogoSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/common/generic-card-logo.svg';
import { normalizeCardBrand, getCardBrandDisplayName } from 'src/utils/cardUtils';

export interface CardBrandLogoProps extends SVGProps<SVGSVGElement> {
  brand?: string | null;
}

export const CardBrandLogo: FC<CardBrandLogoProps> = ({ brand, ...props }) => {
  const norm = normalizeCardBrand(brand);
  switch (norm) {
    case 'visa':
      return <VisaLogoSVG {...props} />;
    case 'mastercard':
      return <MastercardLogoSVG {...props} />;
    case 'amex':
      return <AmexLogoSVG {...props} />;
    case 'discover':
      return <DiscoverLogoSVG {...props} />;
    case 'jcb':
      return <JcbLogoSVG {...props} />;
    case 'diners':
      return <DinersClubLogoSVG {...props} />;
    case 'unionpay':
      return <UnionPayLogoSVG {...props} />;
    case 'maestro':
      return <MaestroLogoSVG {...props} />;
    default:
      return <GenericCardLogoSVG {...props} />;
  }
};

export { getCardBrandDisplayName };
